import NODES_ADD_ACTIONS from '@/store/actions/nodesActions/nodesAddActions.js'
import NODES_PARAMETERS_ACTIONS from '@/store/actions/nodesActions/nodesParametersActions.js'

const NODES_ACTIONS = {
  ...NODES_ADD_ACTIONS,
  ...NODES_PARAMETERS_ACTIONS,
}
export default NODES_ACTIONS;